const state = {
  worktimes: 0.00,
  workovers: 0.00,
  vsurplus: 0.00,
  osurplus: 0.00
}

const mutations = {
  SET_WORKTIMES: (state, worktimes) => {
    state.worktimes = worktimes
  },
  SET_WORKOVERS: (state, workovers) => {
    state.workovers = workovers
  },
  SET_VSURPLUS: (state, vsurplus) => {
    state.token = vsurplus
  },
  SET_OSURPLUS: (state, osurplus) => {
    state.osurplus = osurplus
  }
}

const actions = {
  workdataCount({ commit }, data) {
    let work_time = 0.00
    let work_overtime = 0.00
    data.forEach(element => {
      work_time = work_time + element.work_times
      work_overtime = work_overtime + element.work_overtimes
    })
    commit('SET_WORKTIMES', work_time)
    commit('SET_WORKOVERS', work_overtime)
    commit('SET_VSURPLUS', 0.00)
    commit('SET_OSURPLUS', 0.00)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

